import React, { useState, useEffect } from 'react';
import './image_slider.scss';
import { ReactComponent as IconArrowLeft } from "../../assets/icons/icon_arrow_left.svg";
import { ReactComponent as IconArrowRight } from "../../assets/icons/icon_arrow_right.svg";
import { ReactComponent as IconClose } from "../../assets/icons/icon_close.svg"; 

const ImageSlider = ({ images, initialIndex = 0, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);

    useEffect(() => {
        setCurrentIndex(initialIndex);
    }, [initialIndex]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    return (
        <div className="image-slider">
            {/* <IconClose onClick={onClose} alt="icon-close" className="image-slider-close-icon" /> */}
            <IconArrowLeft onClick={prevSlide} alt="icon-arrow-left" className="image-slider-left-arrow" />
            <div className="image-slider-content d-flex">
                {images.map((image, index) => (
                    <div
                        className={`image-slide ${index === currentIndex ? 'active' : ''}`}
                        key={index}
                        style={{ transform: `translateX(${index * -100}%)`, opacity: index === currentIndex ? 1 : 0 }}>
                        <img src={image.image} alt={`Slide ${index}`} className='image-detail' />
                        <h2 className="image-name">{image.name}</h2>
                    </div>
                ))}
            </div>
            <IconArrowRight onClick={nextSlide} alt="icon-arrow-right" className="image-slider-right-arrow" />
        </div>
    );
};

export default ImageSlider;
